import Roof from "../../../../pages/Editor/Views/Roof/Roof";
import Obstruction from "../../../../pages/Editor/Views/Obstruction/Obstruction";
import Modules from "../../../../pages/Editor/Views/Modules/Modules";
import Irradiance from "../../../../pages/Editor/Views/Irradiance/Irradiance";
import ShadePoint from "../../../../pages/Editor/Views/ShadePoint/ShadePoint";
import Losses from "../../../../pages/Editor/Views/Losses/Losses";
import WhatIf from "../../../../pages/Editor/Views/WhatIf/WhatIf";
import PriceCalculation from "../../../../pages/Editor/Views/PriceCalculation/PriceCalculation";
import SurfaceDraw from "../../../../pages/Editor/Views/SurfaceDraw/SurfaceDraw";
import CustomImagery from "../../../../pages/Editor/Views/Custom Imagery/CustomImagery";
import TapeMeasure from "../../../../pages/Editor/Views/TapeMeasure/TapeMeasure";
import NotFound404 from "../../../../pages/404-Not-Found/NotFound404";
import BuildingAttributes from "../../../../pages/Editor/Views/BuildingAttributes/BuildingAttributes";
import {useCurrentUser} from "../../../../contexts/UserContext";
import Tree from "../../../../pages/Editor/Views/Tree/Tree";
import {useViewerStore} from "../../../../store/store";
import PackingSlipPopup from "../../../../pages/Editor/Views/PackingSlip/PackingSlipPopup";

const Sidebar = () => {

    const pathname = useViewerStore(state => state.pathname)

    const {hasCapability} = useCurrentUser();

    const renderSidebarBasedOnPath = () => {

        switch (pathname) {

            // Accessible by all users
            case '/configure/roof':
                return <Roof/>
            case '/configure/obstruction':
                return <Obstruction/>
            case '/configure/tree':
                return <Tree/>
            case '/configure/modules':
                return <Modules/>
            case '/configure/irradiance':
                return <Irradiance/>
            case '/configure/solar-access':
                return <ShadePoint/>
            case '/configure/losses':
                return hasCapability('Losses_Vendors') ? <Losses/> : <NotFound404/>
            case '/configure/price-calculation':
                return <PriceCalculation/>
            case '/configure/tape-measure':
                return <TapeMeasure/>
            case '/configure/packing-slip':
                return <PackingSlipPopup/>

            // Accessible by users with specific capabilities
            case '/configure/custom-image':
                return hasCapability('Edit_Imagery') && <CustomImagery/>
            case '/configure/surface-draw':
                return (hasCapability('Surface Draw') || hasCapability('Surface_Draw')) && <SurfaceDraw/>
            case '/configure/what-if':
                return hasCapability('What_If') && <WhatIf/>
            case '/configure/building':
                return hasCapability('View_Building_Attributes') && <BuildingAttributes/>
            case '/configure/building/engineering-letter':
                return hasCapability("View_Building_Attributes") && <BuildingAttributes/>
            case '/configure/building/engineering-affidavit':
                return hasCapability("View_Building_Attributes") && <BuildingAttributes/>

            // Default case (404)
            default:
                return <NotFound404/>

        }
    }

    return (
        <>
            {
                renderSidebarBasedOnPath()
            }
        </>
    )
};

export default Sidebar;